import { Link } from 'react-router';

import './Button.css'

function Button({ href, classList, children, ...props }) {
  let classes = "btn";
  if (classList != null) {
    classes = classList
  }

  if (href) {
    return (
      <Link className={classes} to={href} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
}

export default Button;